export abstract class AbsTipoUtente {
    private id!: number
    private tipo: string = 'guest'
    private gerarchia!: number
    public setTipoUtente(id: number, tipo: string, gerarchia: number) {
        this.id = id
        this.tipo = tipo
        this.gerarchia = gerarchia
    }
    public getIdTipo() {
        return this.id
    }
    public getTipoUtente() {
        return this.tipo
    }
    public getGerarchia(): number {
        return this.gerarchia
    }

}